import {RoomsType} from "../components/PricesChart";

export const getFlatsRoomsText = (type: RoomsType) => {
    switch (type) {
        case RoomsType.GENERAL:
            return "";
        case RoomsType.ONE_ROOM:
            return "kawalerek";
        case RoomsType.TWO_ROOMS:
            return "2 pokojowych";
        case RoomsType.THREE_ROOMS:
            return "3 pokojowych";
        case RoomsType.FOUR_OR_MORE_ROOMS:
            return "4 pokojowych (i więcej)";
        default:
            throw new Error("Unknown rooms type");
    }
};
import {RoomsType} from "../components/PricesChart";

export const getFlatsRoomsText = (type: RoomsType) => {
    switch (type) {
        case RoomsType.GENERAL:
            return "";
        case RoomsType.ONE_ROOM:
            return "kawalerek";
        case RoomsType.TWO_ROOMS:
            return "2 pokojowych";
        case RoomsType.THREE_ROOMS:
            return "3 pokojowych";
        case RoomsType.FOUR_OR_MORE_ROOMS:
            return "4 pokojowych (i więcej)";
        default:
            throw new Error("Unknown rooms type");
    }
};
